module.exports = __webpack_public_path__ + "static/img/img_title_06.1fa4573.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_title_06.png
// module id = 558
// module chunks = 1